import LegalPage from '../components/LegalPage';
import { site } from '../config';

export default function RefundPolicy() {
  return (
    <LegalPage
      title="Refund Policy"
      intro={`This policy explains refunds for any paid support you may purchase through ${site.domain}.`}
    >
      <h2>Before you pay</h2>
      <p>
        Any fee for paid support is explained and agreed with you before work begins. You are never charged without
        your approval.
      </p>

      <h2>Requesting a refund</h2>
      <p>
        If we could not resolve your issue, contact us within 7 days of payment at{' '}
        <a href={`mailto:${site.email}`}>{site.email}</a> with your name and the date of your session. We review
        every request and reply within 3 business days.
      </p>

      <h2>When refunds are not available</h2>
      <p>
        Refunds may not be given once an issue has been resolved, or where the problem was caused by the software
        publisher, hardware failure, or changes made outside the session.
      </p>

      <h2>Software purchases</h2>
      <p>
        We do not sell Family Tree Maker licences. For refunds on the software itself, contact the publisher or the
        store where you bought it.
      </p>
    </LegalPage>
  );
}
